import { Link } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SectionHeader from '@/components/feature/SectionHeader';
import FeedbackForm from '@/pages/about/components/FeedbackForm';
import { useSeo } from '@/hooks/useSeo';

const SERVICES = [
  {
    icon: 'ri-movie-2-line',
    title: '影视信息查询',
    desc: '整理电影与电视剧的剧情介绍、演员阵容、导演、类型、地区与年份等结构化资料。',
  },
  {
    icon: 'ri-fire-line',
    title: '最新动态浏览',
    desc: '汇总最新上映与正在热播的影视作品，帮助追剧族第一时间了解影视动态。',
  },
  {
    icon: 'ri-search-eye-line',
    title: '多维筛选与搜索',
    desc: '支持按地区、年份、热门程度筛选，也可通过片名或主演关键词快速定位作品。',
  },
  {
    icon: 'ri-heart-3-line',
    title: '本地收藏',
    desc: '喜欢的影视作品可一键收藏，收藏状态保存在你的浏览器本地，随时回看。',
  },
];

const FRIEND_LINKS = [
  { label: '豆瓣电影', href: 'https://movie.douban.com', desc: '影视评分与影评社区' },
  { label: '猫眼电影', href: 'https://www.maoyan.com', desc: '在线购票与票房资讯' },
  { label: '时光网', href: 'https://www.mtime.com', desc: '电影资讯与资料库' },
  { label: 'IMDb', href: 'https://www.imdb.com', desc: '全球影视资料库' },
];

export default function About() {
  useSeo({
    title: '关于我们 - 美丽小蜜桃3影视大全',
    description:
      '美丽小蜜桃3影视大全是一个专注影视资讯展示与查询的平台，为影视爱好者与追剧族提供电影、电视剧的剧情介绍与演员信息，不提供播放与下载服务。',
    keywords: '美丽小蜜桃3,关于我们,影视大全,影视资讯,剧情介绍,演员表',
  });

  return (
    <SiteLayout>
      <section className="border-b border-background-200 bg-background-100">
        <div className="container-page py-8 md:py-12">
          <Breadcrumb items={[{ label: '首页', to: '/' }, { label: '关于我们' }]} />
          <h1 className="mt-3 text-2xl font-bold text-foreground-950 md:text-4xl">关于美丽小蜜桃3影视大全</h1>
          <p className="mt-3 max-w-3xl text-sm leading-relaxed text-foreground-600 md:text-base">
            我们相信，在按下播放键之前，先读懂一部作品，会让观看体验变得更完整。美丽小蜜桃3影视大全致力于为热爱电影和电视剧的用户，
            提供清晰、整洁、易检索的影视资讯与信息查询服务。
          </p>
        </div>
      </section>

      <section className="container-page pt-10 md:pt-14">
        <SectionHeader title="网站定位" subtitle="资讯展示与信息查询，而非播放平台" />
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="rounded-lg border border-background-200 bg-background-50 p-5 lg:col-span-2 md:p-6">
            <h3 className="text-base font-bold text-foreground-950 md:text-lg">我们做什么</h3>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
              美丽小蜜桃3影视大全面向广大影视爱好者与追剧族，专注于整理和呈现影视作品的公开资讯。
              内容涵盖电影和电视剧两大类别，提供详细的剧情介绍与演员信息，帮助用户在观看前快速了解作品背景与看点，
              同时通过相关推荐帮助用户发现更多同类型作品。
            </p>
            <h3 className="mt-6 text-base font-bold text-foreground-950 md:text-lg">我们不做的事</h3>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
              本站不提供任何在线播放、下载、购买或支付功能，也不存储任何影视资源文件。站内所有内容均为资讯展示性质，
              页面数据为演示用途，仅供参考。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to="/category/movie"
                className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                浏览电影大全
              </Link>
              <Link
                to="/category/tv"
                className="cursor-pointer whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
              >
                浏览电视剧大全
              </Link>
            </div>
          </div>

          <div className="flex flex-col gap-4 rounded-lg bg-accent-100 p-5 md:p-6">
            <h3 className="text-base font-bold text-accent-900">站点信息</h3>
            {[
              { label: '内容类别', value: '电影 / 电视剧' },
              { label: '服务性质', value: '资讯展示与查询' },
              { label: '收藏方式', value: '浏览器本地保存' },
              { label: '反馈邮箱', value: 'feedback@xiaomitao3.film' },
            ].map((item) => (
              <div key={item.label} className="border-b border-accent-200 pb-3 last:border-b-0 last:pb-0">
                <p className="text-xs text-accent-800">{item.label}</p>
                <p className="mt-1 text-sm font-medium text-accent-950">{item.value}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="container-page pt-10 md:pt-14">
        <SectionHeader title="服务范围" subtitle="为用户提供的核心功能" />
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {SERVICES.map((service) => (
            <div key={service.title} className="rounded-lg border border-background-200 bg-background-50 p-5">
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                <i className={`${service.icon} text-xl`} />
              </span>
              <h3 className="mt-4 text-sm font-bold text-foreground-950 md:text-base">{service.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{service.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="container-page pt-10 md:pt-14">
        <SectionHeader title="联系我们" subtitle="有内容纠错、建议或合作意向，欢迎给我们留言" />
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="flex flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
            <div className="flex items-start gap-3">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                <i className="ri-mail-line text-lg" />
              </span>
              <div>
                <p className="text-sm font-semibold text-foreground-950">反馈邮箱</p>
                <p className="mt-0.5 text-sm text-foreground-600">feedback@xiaomitao3.film</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                <i className="ri-time-line text-lg" />
              </span>
              <div>
                <p className="text-sm font-semibold text-foreground-950">回复时间</p>
                <p className="mt-0.5 text-sm text-foreground-600">工作日 1-3 个工作日内回复</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                <i className="ri-chat-smile-2-line text-lg" />
              </span>
              <div>
                <p className="text-sm font-semibold text-foreground-950">合作咨询</p>
                <p className="mt-0.5 text-sm text-foreground-600">请在反馈类型中选择“合作咨询”</p>
              </div>
            </div>
          </div>
          <div className="lg:col-span-2">
            <FeedbackForm />
          </div>
        </div>
      </section>

      <section className="container-page pt-10 md:pt-14">
        <SectionHeader title="友情支持" subtitle="感谢以下影视资讯平台的长期支持" />
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {FRIEND_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="group flex cursor-pointer items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 hover:bg-primary-50"
            >
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-background-100 text-foreground-600 transition-colors group-hover:bg-primary-100 group-hover:text-primary-600">
                <i className="ri-link" />
              </span>
              <span className="min-w-0">
                <span className="block text-sm font-semibold text-foreground-950">{link.label}</span>
                <span className="mt-0.5 block truncate text-xs text-foreground-500">{link.desc}</span>
              </span>
            </a>
          ))}
        </div>
      </section>

      <section className="container-page pt-10 md:pt-14">
        <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
          <h2 className="text-base font-bold text-foreground-950 md:text-lg">版权声明</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-700">
            本站所有影视内容介绍、剧情简介与演职员信息均整理自公开资料，仅用于信息展示与学习交流，版权归原作者及相应权利方所有。
            本站内容为演示数据，如相关权利人认为内容存在不当之处，欢迎通过上方反馈邮箱联系我们，我们将及时核实并处理。
          </p>
          <p className="mt-3 text-sm leading-relaxed text-foreground-700">
            未经许可，任何单位或个人不得以任何形式复制、转载本站内容用于商业用途。
          </p>
        </div>
      </section>
    </SiteLayout>
  );
}